import { httpBatchLink, loggerLink } from '@trpc/client';
import { createTRPCReact } from '@trpc/react-query';
import { createTRPCClient } from '@trpc/client';
import superjson from 'superjson';

// Import the AppRouter type from our type definitions
import type { AppRouter } from '../types/trpc';

// React Query integration for components
export const trpc = createTRPCReact<AppRouter>();

const apiUrl = import.meta.env.VITE_API_URL || "http://localhost:3000";
// Use the Rails proxy endpoint
const url = `${apiUrl}/api`;

// Client factory for React components (with React Query)
export function makeTRPCClient(options?: {
  headers?: () => Record<string, string>
}) {
  return trpc.createClient({
    links: [
      loggerLink({
        enabled: (opts) =>
          process.env.NODE_ENV === 'development' ||
          (opts.direction === 'down' && opts.result instanceof Error),
      }),
      httpBatchLink({
        url: url,
        headers: options?.headers,
        transformer: superjson,
        fetch(url, options) {
          return fetch(url, {
            ...options,
            credentials: 'include', // This ensures cookies are sent
          });
        },
      }),
    ],
  });
}

// Server-side client factory for use in loaders
export function makeServerTRPCClient(request: Request) {
  // Extract cookies from the incoming request
  const cookie = request.headers.get('Cookie');


  return createTRPCClient<AppRouter>({
    links: [
      httpBatchLink({
        url: url,
        transformer: superjson,
        headers: {
          // Forward the cookie header from the incoming request
          ...(cookie ? { Cookie: cookie } : {}),
          // Add any other headers that might be needed
          'X-Forwarded-For': request.headers.get('X-Forwarded-For') || '',
        },
        fetch(url, options) {
          return fetch(url, {
            ...options,
            credentials: 'include',
          });
        },
      }),
    ],
  });
}

// Tip: set batchLink: false in dev or in loaders when you need per-request waterfalls to stay independent.